import * as actionTypes from "../../actions/actionTypes";

const updatedObject = (oldObject, updatedValue) => {
  return {
    ...oldObject,
    ...updatedValue,
  };
};

const initialState = {
  isAuth: false,
  redirectPath: undefined,
  loginRedirect: false,
  redirectToOnboardingPath: undefined,
};

const authSuccess = (state, action) => {
  return updatedObject(state, {
    isAuth: true,
  });
};

const authLogout = (state, action) => {
  return updatedObject(state, {
    isAuth: false,
    redirectPath: action.path,
  });
};

const authRedirect = (state, action) => {
  return updatedObject(state, {
    loginRedirect: true,
  });
};

const authInit = (state, action) => {
  return updatedObject(state, {
    loginRedirect: action.payload.loginRedirect,
    redirectToOnboardingPath: action.payload.path,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_REDIRECT:
      return authRedirect(state, action);
    case actionTypes.AUTH_INIT:
      return authInit(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);
    default:
      return state;
  }
};

export default reducer;
